import { required, numeric } from "vuelidate/lib/validators";
export default {
    items: {
        $each: {
            provider_id: {
                required,
            },
            field_relation: {},
            field_id: {
                required,
            },
            mapping: {},
            field_type: {},
            field_format: {},
            default_value: {},
            required: {},
        },
    },
}